/*
 * WELLF science page interactions: table-of-contents scroll-spy + sticky,
 * FAQ accordion, and the references show/hide toggle. All progressive
 * enhancement - the page reads fine with JS disabled.
 */
(function () {
  'use strict';

  function tocOffset() {
    var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--toc-nav-offset'), 10);
    return isNaN(v) ? 104 : v;
  }

  /* TOC: sticky pinning + active-link scroll-spy */
  (function toc() {
    var toc = document.querySelector('.toc');
    var links = Array.prototype.slice.call(document.querySelectorAll('.toc__link'));
    if (!toc || !links.length) return;

    var targets = links.map(function (l) {
      var id = (l.getAttribute('href') || '').replace('#', '');
      return id ? document.getElementById(id) : null;
    });

    // Spacer prevents the page jumping when the TOC switches to fixed.
    var spacer = document.createElement('div');
    spacer.className = 'toc__spacer';
    toc.parentNode.insertBefore(spacer, toc.nextSibling);

    var baseTop = 0;
    function measure() {
      toc.classList.remove('toc--stuck');
      spacer.style.height = '0px';
      baseTop = toc.getBoundingClientRect().top + window.pageYOffset;
    }

    function onScroll() {
      var offset = tocOffset();
      var stuck = window.pageYOffset >= baseTop - offset;
      toc.classList.toggle('toc--stuck', stuck);
      spacer.style.height = stuck ? toc.offsetHeight + 'px' : '0px';

      // scroll-spy: last section whose top has crossed the offset line
      var line = offset + 80;
      var active = 0;
      for (var i = 0; i < targets.length; i++) {
        if (targets[i] && targets[i].getBoundingClientRect().top - line <= 0) active = i;
      }
      links.forEach(function (l, i) {
        if (i === active) l.setAttribute('aria-current', 'true');
        else l.removeAttribute('aria-current');
      });
    }

    var ticking = false;
    function request() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; onScroll(); });
    }

    measure();
    onScroll();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); });
  })();

  /* FAQ accordion - each item opens/closes independently */
  (function faq() {
    var toggles = Array.prototype.slice.call(document.querySelectorAll('.faq__toggle'));
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (panel) panel.hidden = open;
      });
    });
  })();

  /* Cover video: pick the playable transparent format, same routing as the
     product page. Apple devices (WebKit) get the HEVC/hvc1 mp4 whose alpha
     channel renders transparent; everyone else gets the VP9 webm. Selecting via
     canPlayType avoids iOS Safari picking the webm and painting it without its
     alpha (a black box behind the rotating sweet). */
  (function coverVideo() {
    var v = document.getElementById('coverVideo');
    if (!v || v.src) return;
    var canHevc = v.canPlayType && v.canPlayType('video/mp4; codecs="hvc1"');
    var src = canHevc ? v.getAttribute('data-mp4') : v.getAttribute('data-webm');
    if (src) v.src = src;
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () {});
  })();

  /* References show-all / hide toggle */
  (function refs() {
    var btn = document.querySelector('[data-refs-toggle]');
    var wrap = document.querySelector('.refs__list-wrap');
    if (!btn || !wrap) return;
    btn.addEventListener('click', function () {
      var collapsed = wrap.getAttribute('data-collapsed') === 'true';
      wrap.setAttribute('data-collapsed', String(!collapsed));
      btn.setAttribute('aria-expanded', String(collapsed));
      if (!collapsed) wrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  })();
})();
